import { render, staticRenderFns } from "./ReferencePayment.vue?vue&type=template&id=5984a2de"
import script from "./ReferencePayment.vue?vue&type=script&lang=js"
export * from "./ReferencePayment.vue?vue&type=script&lang=js"
import style0 from "./ReferencePayment.vue?vue&type=style&index=0&id=5984a2de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports